import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import updateLocale from 'dayjs/plugin/updateLocale';

export function useAppDayjs() {
  dayjs.extend(updateLocale);
  dayjs.extend(weekday);
  dayjs.extend(weekOfYear);
  // const getTime = () => {
  //   console.log(
  //     dayjs().weekday(0).format('YYYY-MM-DD HH:mm:ss'), // 1
  //     dayjs('2022-1-2').week(),
  //     dayjs('2022-1-3').week(),
  //   );
  // };

  // 设置时区
  const locale = dayjs.locale();

  dayjs.updateLocale(locale, {
    weekStart: 1, // 设置一周的起始日为周1
    yearStart: 1, // 设置一年中的第一周必须包含1月1日
    // months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    // weekdays: '一_二_三_四_五_六_七'.split('_'),
  });
}
